import { render, staticRenderFns } from "./XQuickDataView.vue?vue&type=template&id=a122cef0&scoped=true"
import script from "./XQuickDataView.vue?vue&type=script&lang=js"
export * from "./XQuickDataView.vue?vue&type=script&lang=js"
import style0 from "./XQuickDataView.vue?vue&type=style&index=0&id=a122cef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a122cef0",
  null
  
)

export default component.exports